var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg61(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "71") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-day",
    transform: "translate(-3804.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(25.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 71,
    transform: "translate(3779.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6959238,5.99771429 C12.6869566,5.99771429 14.3887559,7.23628542 15.0728545,8.98496028 C14.0421273,10.3448074 13.3788369,11.9969036 13.2278589,13.7947429 L13.2278589,13.7947429 L12.6954618,13.7947429 C11.2865018,13.7947429 9.98758693,14.2646144 8.94673993,15.0561676 C7.21832165,14.3639682 5.99771429,12.6724652 5.99771429,10.6959238 C5.99771429,8.10121265 8.10121265,5.99771429 10.6959238,5.99771429 Z",
    id: "Combined-Shape",
    fill: "#FED100"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    x: 0,
    y: 9.89622857,
    width: 4.49828571,
    height: 1.59939048,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    transform: "translate(4.723172, 16.668692) rotate(-45.000000) translate(-4.723172, -16.668692) ",
    x: 2.47402916,
    y: 15.8689972,
    width: 4.49828571,
    height: 1.59939048,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    transform: "translate(16.668724, 4.723140) rotate(-45.000000) translate(-16.668724, -4.723140) ",
    x: 14.4195813,
    y: 3.92344506,
    width: 4.49828571,
    height: 1.59939048,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    transform: "translate(4.723170, 4.723160) rotate(45.000000) translate(-4.723170, -4.723160) ",
    x: 2.47402729,
    y: 3.92346441,
    width: 4.49828571,
    height: 1.59939048,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    x: 9.89622857,
    y: 0,
    width: 1.59939048,
    height: 4.49828571,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7244459,11.7304317 L29.8195358,11.9851325 L30.2348776,13.159485 L31.4654086,12.9665585 C31.7680933,12.9190766 32.0760759,12.8950857 32.3876571,12.8950857 C35.6449158,12.8950857 38.2854095,15.5355794 38.2854095,18.7928381 C38.2854095,21.8952594 35.884491,24.4521499 32.7678056,24.6727604 L35.0397308,20.8914667 L29.4014263,20.8914667 L32.3003216,14.3939429 L22.1551334,14.3939429 L19.2549524,24.6904095 L12.6954618,24.6905905 C10.1001509,24.6905905 7.99695238,22.5875919 7.99695238,19.992381 C7.99695238,17.4694535 9.98483485,15.4113953 12.4803517,15.2990054 L12.6954618,15.2941714 L14.6066334,15.2941714 L14.7220894,13.920195 C15.0589611,9.90852389 18.425778,6.79740952 22.4785335,6.79740952 C25.7114959,6.79740952 28.5662324,8.78595339 29.7244459,11.7304317 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FED100",
    points: "25.3903238 26.190019 20.3922286 26.190019 23.2911238 15.8939429 29.9885714 15.8939429 27.0896762 22.3914667 32.3876571 22.3914667 22.5913905 38.6852571"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg61);
export default __webpack_public_path__ + "static/media/61.150a5049a8cac9cd0c91afc6e690c1c6.svg";
export { ForwardRef as ReactComponent };